export default __webpack_public_path__ + "static/media/webswfte.dad3dc4b.ttf";